import React, { PropsWithChildren, useState } from 'react';
import { DropdownField } from './partials/DropdownField';
import { Desktop } from '../breakpoints/Desktop';
import { Mobile } from '../breakpoints/Mobile';
import { DropdownMenu } from './partials/DropdownMenu';
import { ConfirmModal } from '../modal/ConfirmModal';
import { Dropdown } from './Dropdown';
import { noop } from 'lodash';

export const SimpleDropdown = ({
    name, renderPreview, maxHeight,
    children, onCancel = noop
}: Props) => {

    const [open, setOpen] = useState(false);
    const toggle = () => setOpen(!open);

    const cancel = () => {
        toggle();
        onCancel();
    };

    return (
        <Dropdown open={open} setOpen={setOpen}>
            <DropdownField active={open} onClick={toggle}>
                {renderPreview()}
            </DropdownField>

            {open && (
                <>
                    <Desktop>
                        <DropdownMenu onClick={toggle} maxHeight={maxHeight}>
                            {children}
                        </DropdownMenu>
                    </Desktop>

                    <Mobile>
                        <ConfirmModal title={name} active={true} onReject={cancel} onConfirm={toggle}>
                            {children}
                        </ConfirmModal>
                    </Mobile>
                </>
            )}
        </Dropdown>
    );
};

type Props = PropsWithChildren<{
    name: string;
    renderPreview: () => JSX.Element;
    maxHeight?: number;
    activeByDefault?: boolean;
    onCancel?: () => void;
}>;
